import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";
import ReportTasksChart_Settings from "./settings";

export default class ReportTasksCategoryChart extends Report<ReportTasksChart_Settings> {

    static reportName           : string = "Category-based Chart"

    declare settings             : ReportTasksChart_Settings // redefine any


    constructor(data: ReportConfig) {
        data.type           = ViewType.REPORT_TASKS_CATEGORY_CHART
        super(data);

        this.icon           = "isvg-tasks-chart"
        this.description    = "Select a data source, define grouping dimensions, and choose a metric to instantly generate an interactive chart that reveals trends, distributions, and key insights."

        this.settings       = new ReportTasksChart_Settings(data.settings)

    }

    static initFromSavedView(savedView: SavedView): ReportTasksCategoryChart {
        return new ReportTasksCategoryChart(savedView.toReportConfig());
    }

    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportTasksChart_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectIds = [projectId]
    }

    save(){
        console.log("Not implemented")
    }
}
